import { render, staticRenderFns } from "./SkillField.vue?vue&type=template&id=0fb48f78&scoped=true"
import script from "./SkillField.vue?vue&type=script&lang=js"
export * from "./SkillField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb48f78",
  null
  
)

export default component.exports